/**
 * Factory to create a WebSocket instance
 *
 * @param url: string
 * @returns WebSocket instance
 */
export const createWebSocket = (url: string) => new WebSocket(url)
